import React from 'react';
import ReactDOM from 'react-dom/client';
import 'katex/dist/katex.min.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { Capacitor } from '@capacitor/core';

if (Capacitor.isNativePlatform()) {
  document.body.classList.add('native-app');
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <App />
);

// Unregister service worker — it caches old JS bundles and prevents deploys
// from taking effect until all tabs are closed.
serviceWorkerRegistration.unregister();
